import React from "react";
import "./Card.css";

const Card = ({ title, value, change, since }) => {
  return (
    <div className="card card-stats mb-4 mb-xl-0 shadow-sm CRM-cards">
      <div className="card-body w-30 h-30">
        <div className="row">
          <div className="col">
            <h5
              className="card-title  mb-2"
              style={{
                fontFamily: "Inter",
                fontSize: "18px",
                color: "#4E5D78",
                fontWeight: 600,
              }}
            >
              {title}
            </h5>

            <span
              className="h2 font-weight-bold mb-0 fs-4 "
              style={{ fontFamily: "Inter", color: "#4E5D78", fontWeight: 600 }}
            >
              {value}
            </span>

            {/* <span
            className={
              change.startsWith("-") ? "text-danger mr-2" : "text-success mr-2"
            }
          >
            <i
              className={
                change.startsWith("-") ? "fas fa-arrow-down" : "fas fa-arrow-up"
              }
            ></i>{" "}
            {change}
          </span> */}
          </div>
        </div>

        <p className="mt-3 mb-0 text-muted text-sm">
          <span className="text-nowrap">{since}</span>
        </p>
      </div>
    </div>
  );
};

export default Card;
